// extracted by mini-css-extract-plugin
export var accesDirectContainer = "acces-direct-module--acces-direct-container--c5a3f";
export var accesDirectDescription = "acces-direct-module--acces-direct-description--39c95";
export var accesDirectItem = "acces-direct-module--acces-direct-item--67a91";
export var accesDirectItemDescription = "acces-direct-module--acces-direct-item-description--ab0d4";
export var accesDirectItemImg = "acces-direct-module--acces-direct-item-img--74f4a";
export var accesDirectTitle = "acces-direct-module--acces-direct-title--fa414";
export var editButton = "acces-direct-module--edit-button--e1a6d";
export var editButtonTitle = "acces-direct-module--edit-button-title--ec5f3";